import { useRouter, LocationQueryRaw } from 'vue-router';

const useJumpWithQuery = () => {
  const router = useRouter();
  const jumpWithQuery = (path: string, query: LocationQueryRaw) => {
    router.push({
      path,
      query,
    });
  };
  return jumpWithQuery;
};

export default useJumpWithQuery;
